var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"brand"},[_c('span',{staticClass:"prepend"},[_vm._v("Follow")]),_c('span',{staticClass:"append"},[_vm._v("Up")])])
}]

export { render, staticRenderFns }